import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { GenericDocumentStateFlowProps } from "models/propTypes/documentPropTypes";
//#endregion
//#region components
import { LinearStateFlowContainer, useMountedState } from "components/common";
import { useGenericDocumentService } from "serviceHooks";
//#endregion

const GenericDocumentStateFlow: React.FC<GenericDocumentStateFlowProps> = (props) => {
  const genericDocumentService = useGenericDocumentService();
  const { getMounted } = useMountedState();
  const { id } = props;
  const [states, setStates] = React.useState<WintSuperkollAPIModel.EntityStateLog[]>();

  React.useEffect(() => {
    genericDocumentService.getStateLogs(id).then((items) => {
      if (getMounted()) {
        setStates(items);
      }
    });
  }, [id]);

  return <>{states && <LinearStateFlowContainer steps={states} translationKey={"Document.GenericDocumentState"} />}</>;
};

export default GenericDocumentStateFlow;
